import { createStore as _createStore, applyMiddleware } from 'redux'
import { routerMiddleware } from 'react-router-redux'
import thunk from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import { reactReduxFirebase, getFirebase } from 'react-redux-firebase'

import firebaseConfig from 'config/firebase'

const reduxDevToolsConfig = {}
const reduxFirebaseConfig = { userProfile: 'users' }

export default function createStore (history) {
  // Sync dispatched route actions to the history
  const reduxRouterMiddleware = routerMiddleware(history)

  const middleware = [
    reduxRouterMiddleware,
    thunk.withExtraArgument(getFirebase)
  ]

  const reducer = require('./modules/reducer').default

  const composeEnhancers = composeWithDevTools(reduxDevToolsConfig)
  const store = _createStore(
    reducer,
    /* preloadedState, */ composeEnhancers(applyMiddleware(...middleware)),
    reactReduxFirebase(firebaseConfig, reduxFirebaseConfig)
  )

  if (module.hot) {
    module.hot.accept('./modules/reducer', () => {
      store.replaceReducer(require('./modules/reducer').default)
    })
  }

  return store
}



// WEBPACK FOOTER //
// ./src/store/create.js